const styles = {
  modalPopup: {
    padding: "0",
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  popupHeader: {
    padding: "0px",
    backgroundColor: "#000",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: "32px",
    marginBottom: "32px",
  },
  popupHeaderInfo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  popupHeaderText: {
    fontSize: "24px",
    fontWeight: 400,
    color: "#fff",
  },
  popupClose: {
    float: "right",
    color: "#fff",
    "& .MuiSvgIcon-root": {
      fontSize: "24px",
    },
  },
  popupContent: {
    padding: "32px",
    margin: "0 auto",
    width: "700px",
    maxWidth: "700px",
    minHeight: "450px",
    backgroundColor: "#000",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    borderRadius: "32px",
    border: "2px solid #323232",
    "@media (max-width:760px)": {
      margin: "0 20px",
    },
  },
  popupMainContent: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    flex: 1,
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media (max-width:700px)": {
      flexDirection: "column",
    },
  },
  popupLeftSide: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: "32px",
  },
  popupRightSide: {
    width: "200px",
    display: "flex",
    justifyContent: "center",
    "@media (max-width:699px)": {
      width: "100%",
    },
  },
  shareLink: {
    color: "#fff",
    position: "relative",
  },
  qrCode: {
    height: "200px",
    textAlign: "center",
    "& > p": {
      textAlign: "left",
    },
  },
  formControl: {
    display: "flex",
    color: "#fff",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    position: "relative",
    "& .MuiFormControl-root": {
      height: "56px",
      width: "400px",
      margin: "0 !important",
      color: "#757575",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      "@media (max-width:699px)": {
        width: "100%",
      },
    },
    "& .MuiSvgIcon-root": {
      marginRight: "16px",
    },
    "& .MuiInput-root": {
      backgroundColor: "#161616",
      marginTop: "0px",
      paddingTop: "16px",
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      "&.Mui-disabled": {
        backgroundColor: "#0b0b0b",
      },
    },
    "& .MuiInputBase-input": {
      color: "#fff",
      borderBottom: "1px solid #757575",
      padding: "8px 16px",
      backgroundColor: "#161616",
      "&.Mui-disabled": {
        backgroundColor: "#0b0b0b",
        color: "#757575",
        "-webkit-text-fill-color": "#757575",
      },
    },
  },
  textField: {
    flex: "1",
    backgroundColor: "transparent !important",
    "& label": {
      color: "#757575",
      zIndex: 99,
      padding: "0 16px",
    },
    "& label.Mui-disabled": {
      color: "#757575",
    },
    "& label.Mui-focused": {
      color: `#757575`,
      padding: "8px 16px",
    },
    "& label.MuiFormLabel-filled": {
      padding: "8px 16px",
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      bottom: "-20px",
      left: "16px",
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "400",
    },
    "& .Mui-error": {
      color: "#FF0000 !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      height: "40px",
      boxSizing: "border-box",
    },
    "& .MuiInput-root::before": {
      border: "none !important",
    },
    "& .MuiInput-root::after": {
      border: "none",
    },
  },
  modalDialog: {
    "& > div > .MuiPaper-root": {
      backgroundColor: "rgba(0,0,0,0.8)",
    },
    "& .MuiDialogActions-root": {
      paddingTop: "38px",
      margin: "0 auto",
      maxWidth: "500px",
      paddingLeft: "10px",
      justifyContent: "center",
      "@media (max-width:576px)": {
        bottom: 0,
        position: "absolute",
        width: "100%",
      },
    },
    "& .MuiIconButton-root": {
      padding: "0px",
    },
  },
  shareSettingsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  shareSettings: {
    color: "#fff",
    paddingTop: "12px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    marginBottom: "24px",
  },
  label: {
    color: "#fff",
    fontSize: "14px",
  },
  track: {
    height: "3px",
    top: "4px",
    backgroundColor: "#fff",
    position: "relative",
  },
  shareButtons: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  shareButton: {
    padding: "8px 16px",
    backgroundColor: "#8F0339",
    color: "#fff",
    textAlign: "center",
    width: "100%",
    maxWidth: "188px",
    height: "40px",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "24px",
    borderRadius: "24px",
    "&.Mui-disabled": {
      opacity: "0.5",
      background: "#757575",
      color: "#fff",
      pointerEvents: "none",
    },
  },
  shareCopyButton: {
    padding: "8px 16px",
    color: "#F50561",
    textAlign: "center",
    width: "100%",
    maxWidth: "188px",
    height: "40px",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "24px",
    borderRadius: "24px",
    border: "1px solid #757575",
    "& .MuiSvgIcon-root": {
      fontSize: "24px !important",
    },
  },
  checkboxContainer: {
    "& .MuiFormControlLabel-label": {
      color: "#fff",
      marginLeft: "16px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      "&.Mui-disabled": {
        color: "#fff",
      },
    },
    "& .MuiFormControlLabel-root": {
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
    "& .MuiCheckbox-root": {
      padding: "4px",
      marginLeft: "11px",
    },
    "& .MuiCheckbox-root .MuiSvgIcon-root": {
      fill: "#757575",
      fontSize: "16px",
    },
    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
      fill: "#F50561",
    },
  },
  contactList: {
    padding: "16px",
    border: "1px solid #323232",
    background: "#000",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 1px rgba(0, 0, 0, 0.25)",
    margin: "0 auto",
    width: "calc(100% - 80px)",
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    position: "absolute",
    top: "56px",
    left: "40px",
    zIndex: "999",
    maxHeight: "216px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#161616",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },
  contactListItem: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    padding: "8px",
    gap: "8px",
    borderRadius: "8px",
    "&:hover": {
      background: "#161616",
    },
  },
  contactListItemTitle: {
    textAlign: "left",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    padding: "4px 8px",
  },
  contactListItemText: {
    textAlign: "left",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    padding: "4px 8px",
    borderRadius: "16px",
    cursor: "pointer",
    "&:hover": {
      background: "#431325",
    },
  },
};

export default styles;
